<template>
    <div class="footerbar">
      <div class="mainContainer flex_space">
         <!--logo部分-->
         <!--<div class="gw_footerbarlogo">-->
            <!--<div><img src="../assets/logo.png" alt=""></div>-->
            <!--<p>杭州牛盾网络技术有限公司</p>-->
         <!--</div>-->
        <!--中间部分-->
        <div class="gw_footerbarMain">
          <ul class="flex gw_footermenu">
            <li @click="goUrl('product1')"><span>漏洞扫描</span></li>
            <li @click="goUrl('product3')"><span>专家服务</span></li>
            <li @click="goUrl('aboutUs')"><span>联系我们</span></li>
            <li @click="goUrl('agreement')"><span>隐私协议</span></li>
          </ul>
          <div class="footer_end flexCol_aroud">
            <p class="footer_licence"><a href="https://beian.miit.gov.cn/" target="_miitbeian">浙ICP备16008835号</a> | <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002012547" target="_beian"><img src="../assets/police.png">浙公网安备 33011002012547号</a> | <a href="https://www.miit.gov.cn" target="_miitbeian">ICP证：浙B2-20170021号</a> | <a >IDC&amp;ISP：B1-20170630</a></p>
            <p class="footer_copyright">Copyright © 2019 Newdun.com Inc. <span>杭州牛盾网络技术有限公司</span></p>
          </div>
        </div>
        <!--右边部分-->
        <div class="flex gw_connectBox">
          <div class="gw_phoneBox">
            <div class="gw_phoneTitle">牛盾网络客服专线</div>
            <div class="gw_phone">0571-8861-6565</div>
            <div>周一到周五  9:00至18:00</div>
          </div>
          <div class="gw_QRcord"></div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "footerbar",
    methods:{
      goUrl(url){
        this.$router.push({name:url,params:{tabName:'fourth'}});
        window.scrollTo({
          top:0
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .footerbar{
    height:100%;
    background: #313131;
    font-weight: bold;
    .mainContainer{
      align-items: center;
      padding-top:0 !important;
    }
    .gw_footerbarlogo{
      img{
        width:218px;
        height:34px;
      }
      p{
        font-size: 18px;
        color: #D8D8D8;
        letter-spacing: 0.5px;
      }
    }
    .gw_footerbarMain{
      .gw_footermenu{
        li{
          text-align: left;
          width:80px;
          height:23px;
          line-height: 23px;
          border-right:1px solid rgba(151,151,151,.7);
          margin-right:20px;
          span{
            font-size:14px;
            color:#D8D8D8;
            cursor: pointer;
            font-family: 'pingfang';
          }
          &:last-child{
            border-right:none;
          }
          &:hover{
            span{
              color:#fff;
            }
          }
        }
      }
      .footer_end{
        font-size: 12px;
        text-align: center;
        color: #fff;
        p{
          a{
            color: #D8D8D8;
            text-decoration: none;
            font-family: 'pingfang';
            img{
              position: relative;
              /*top:6px;*/
              width:15px;
              height:16px;
              vertical-align: middle;
            }
          }
          text-align: left;
          font-size: 12px;
          color: #D8D8D8;
          font-family: 'pingfang';
        }

        .footer_licence{
          margin-top:20px;
        }
        .footer_copyright{
          font-size:14px;
        }
      }
      .gw_copy{
        font-size: 12px;
        color: #D8D8D8;
      }
      .gw_record{
        margin:28px 0 25px;
      }
    }
    .gw_connectBox{
      .gw_phoneBox{
        text-align: left;
        padding-top:5px;
        margin-right:17px;
        div{
          font-size:12px;
          color:#D8D8D8;
          font-family: 'pingfang';
        }
        .gw_phoneTitle{
          letter-spacing: 4.5px;
        }
        .gw_phone{
          font-size:18px;
          margin:5px 0;
        }
      }
      .gw_QRcord{
        width:80px;
        height:81.7px;
        background:url("../assets/QRcord.png") no-repeat center;
        background-size:100% 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footerbar.vue